module.exports = __webpack_public_path__ + "static/img/bluewalk.30e8462.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/VX/bluewalk.png
// module id = Im6E
// module chunks = 1